<template>
	<div class="bind-phone-warpper">
		<!-- 遮罩层 - 阻止点击外部 -->
		<div class="block-overlay" @click.prevent.stop="handleClickOverlay"></div>
		<!-- 固定头部 -->
		<!-- <div class="fixed-header">
			<div class="header-content">
				<div class="header-title">绑定手机号码</div>
				<div class="header-tip">为了保障您的账号安全，请先绑定手机号</div>
			</div>
		</div> -->
		<div class="bind-phone-page">
			<div class="phone-container">
				<div class="form-content">
					<h2 class="page-title">绑定手机号码</h2>
					<div class="header-tip">为了保障您的账号安全，请先绑定手机号</div>
					<el-form ref="formRef" :model="form" :rules="rules" label-position="top" label-width="120px">
						<el-form-item label="手机号码：" prop="phone">
							<el-input v-model.trim="form.phone" placeholder="请输入手机号码" />
						</el-form-item>
						<el-form-item label="短信验证码：" prop="verifyCode">
							<div class="code-wrapper">
								<el-input v-model.trim="form.verifyCode" autocomplete="off" placeholder="请输入短信验证码"></el-input>
								<el-button :disabled="waitNum > 0" plain type="primary" @click="toSendMsg">
									{{ waitNum > 0 ? waitNum + '秒后重新发送' : '发送验证码' }}
								</el-button>
							</div>
						</el-form-item>
					</el-form>
					<div class="form-actions">
						<el-button size="medium" type="primary" @click="handleConfirm"> 确定 </el-button>
					</div>
					<div class="warning-tip">
						<i class="el-icon-warning"></i>
						<span>绑定手机号后才能正常使用系统功能</span>
					</div>
				</div>
			</div>

			<div class="page-footer">
				<div class="foot-copy">
					<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">©2025 量大（北京）信息科技研究院有限公司<span>京ICP备2024096922号-3</span></a>
					<a @click="handleClickXKZ" target="_blank" style="cursor: pointer">出版物许可证</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getMemberSms } from '@/api/user/login';
import TMessage from '@/utils/TMessage';
import { postMemberPhoneNew, postMemberUpdateInfo } from '@/api/user/user.js';
import mtils from 'mtils';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'BindPhone',
	data() {
		const validatePhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入手机号码'));
			}
			if (!mtils.validation.isMobile(value)) {
				return callback(new Error('手机号码格式不正确'));
			}
			callback();
		};
		return {
			form: {
				phone: '',
				verifyCode: '',
				verifyKey: '',
				oldPhone: ''
			},
			rules: {
				phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
				verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
			},
			waitNum: 0,
			wtimer: null,
			cbwUrl: require('@/assets/images/20260304-100309.png')
		};
	},
	computed: {
		...mapGetters('User', ['uinfo', 'uisLogin'])
	},
	methods: {
		handleClickXKZ() {
			window.open(this.cbwUrl);
		},
		handleClickOverlay() {
			TMessage.error('请先绑定手机号，才能正常使用系统功能');
		},

		...mapActions('User', ['getUserInfo']),
		toSendMsg() {
			this.$refs.formRef.validateField('phone', async errorMessage => {
				if (!errorMessage) {
					try {
						this.startWait();
						getMemberSms(this.form.phone).then(res => {
							let { code, data, msg } = res;
							if (code == 200) {
								this.form.verifyKey = data;
								TMessage.success('验证码已发送');
							} else if (msg) {
								this.stopWait();
								TMessage.warning(msg);
							} else {
								this.stopWait();
								TMessage.warning('短信发送失败');
							}
						});
					} catch (error) {
						this.stopWait();
						TMessage.error('发送验证码失败');
					}
				}
			});

			// if (!this.form.phone) {
			// 	TMessage.error('请输入手机号码');
			// 	return;
			// }
			// if (!mtils.validation.isMobile(this.form.phone)) {
			// 	TMessage.error('手机号码格式不正确');
			// 	return;
			// }
			// this.startWait();
			// getMemberSms(this.form.phone).then(res => {
			// 	let { code, data, msg } = res;
			// 	if (code == 200) {
			// 		this.form.verifyKey = data;
			// 		TMessage.success('验证码已发送');
			// 	} else if (msg) {
			// 		this.stopWait();
			// 		TMessage.warning(msg);
			// 	} else {
			// 		this.stopWait();
			// 		TMessage.warning('短信发送失败');
			// 	}
			// });
		},

		startWait() {
			this.waitNum = 60;
			if (this.wtimer) {
				this.stopWait();
			}
			this.wtimer = setInterval(() => {
				this.waitNum--;
				if (this.waitNum <= 0) {
					this.stopWait();
				}
			}, 1000);
		},

		stopWait() {
			clearInterval(this.wtimer);
			this.wtimer = null;
			this.waitNum = 0;
		},

		handleCancel() {
			this.stopWait();
			this.resetForm();
			this.$router.go(-1);
		},

		resetForm() {
			this.$refs['formRef'].resetFields();
		},

		handleConfirm() {
			this.$refs['formRef'].validate(valid => {
				if (valid) {
					this.validatePhone();
				}
			});
		},

		validatePhone() {
			postMemberPhoneNew(this.form).then(res => {
				let { code, data, msg } = res;
				if (code == 200) {
					this.updatePhoneMail();
				} else if (msg) {
					TMessage.warning(msg);
				} else {
					TMessage.warning('手机号码验证失败');
				}
			});
		},

		updatePhoneMail() {
			const params = {
				consumerPhone: this.form.phone
			};
			postMemberUpdateInfo(params).then(res => {
				let { code, data, msg } = res;
				if (code == 200) {
					TMessage.success('手机号码绑定成功');
					this.getUserInfo().then(() => {
						this.$router.replace({ name: 'Home' });
					});
				} else if (msg) {
					TMessage.warning(msg);
				} else {
					TMessage.warning('手机号码更新失败');
				}
			});
		},

		// 阻止浏览器后退
		preventBack() {
			// 添加历史记录，阻止直接后退
			history.pushState(null, null, document.URL);
		},

		// 处理浏览器后退事件
		handlePopState(e) {
			// 如果未绑定手机号，阻止后退
			if (this.uisLogin && !this.uinfo?.consumerPhone) {
				TMessage.warning('请先绑定手机号码');
				this.preventBack();
			}
		}
	},
	mounted() {
		// 页面加载时阻止后退操作
		this.preventBack();
		// 监听浏览器后退按钮
		window.addEventListener('popstate', this.handlePopState);
	},

	beforeDestroy() {
		//事件销毁
		this.stopWait();
		// 移除事件监听
		window.removeEventListener('popstate', this.handlePopState);
	},

	beforeRouteLeave(to, from, next) {
		// 如果未绑定手机号，阻止离开
		if (this.uisLogin && !this.uinfo?.consumerPhone) {
			// TMessage.warning('请先绑定手机号码');
			this.$store.dispatch('User/logout');
			next(false);
		} else {
			next();
		}
	}
};
</script>

<style lang="less" scoped>
.bind-phone-warpper {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: #f8fafc;
	z-index: 13;
}

// 遮罩层 - 阻止点击外部导航
.block-overlay {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 9998;
	background: transparent;
}

// 固定头部
.fixed-header {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 14;
	background: transparent;
	// background: linear-gradient(135deg, #155dfc 0%, #66b1ff 100%);
	padding: 20px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
	pointer-events: none; // 禁止点击

	.header-content {
		text-align: center;
		color: #fff;
	}

	.header-title {
		font-size: 20px;
		font-weight: 600;
		margin-bottom: 8px;
	}

	.header-tip {
		font-size: 14px;
		opacity: 0.9;
	}
}

.bind-phone-page {
	padding-top: 30px; // 为固定头部留出空间
	min-height: 100vh;
	background-color: #f8fafc;
	position: relative;
	z-index: 9999;

	.form-content {
		width: 500px;
		margin: 0 auto;

		.header-tip {
			font-size: 16px;
			text-align: center;
			margin-bottom: 48px;
			font-weight: 600;
		}
	}

	.page-footer {
		.foot-copy {
			margin-top: 28px;
			font-size: 12px;
			color: #94a3b8;
			text-align: center;
			a {
				color: #94a3b8;
				text-decoration: none;
			}
			a:hover {
				color: #475569;
				text-decoration: none;
			}
			a:first-child {
				margin-right: 10px;
			}
		}
	}

	.phone-container {
		width: 80%;
		margin: 0 auto;
		background: white;
		border-radius: 12px;
		padding: 40px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
		height: calc(100vh - 240px);
		overflow: auto;

		.page-title {
			text-align: center;
			// margin-bottom: 40px;
			color: #334155;
			font-size: 26px;
			font-weight: 600;
		}

		.code-wrapper {
			display: flex;
			align-items: center;

			.el-input {
				flex: 1;
			}

			.el-button {
				margin-left: 10px;
				min-width: 120px;
			}
		}

		.form-actions {
			margin-top: 40px;
			display: flex;
			justify-content: center;
			gap: 20px;

			.el-button {
				width: 200px;
				height: 44px;
				font-size: 16px;
			}
		}

		.warning-tip {
			margin-top: 30px;
			padding: 16px;
			background-color: #fdf6ec;
			border: 1px solid #fde68a;
			border-radius: 12px;
			text-align: center;
			color: #d97706;
			font-size: 14px;

			i {
				margin-right: 8px;
			}
		}
	}
}
</style>
